import { render, staticRenderFns } from "./ThirdPartyModal.vue?vue&type=template&id=32d706f8&scoped=true"
import script from "./ThirdPartyModal.vue?vue&type=script&lang=ts"
export * from "./ThirdPartyModal.vue?vue&type=script&lang=ts"
import style0 from "./ThirdPartyModal.vue?vue&type=style&index=0&id=32d706f8&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "32d706f8",
  null
  
)

export default component.exports